import { render } from "./GoalType.vue?vue&type=template&id=4122b6e2"
import script from "./GoalType.vue?vue&type=script&lang=js"
export * from "./GoalType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/GoalType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4122b6e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4122b6e2', __exports__)) {
    api.reload('4122b6e2', __exports__)
  }
  
  module.hot.accept("./GoalType.vue?vue&type=template&id=4122b6e2", () => {
    api.rerender('4122b6e2', render)
  })

}


export default __exports__